import { Component, EventEmitter, Input, OnInit, Output, Type, ViewChild,ChangeDetectorRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
// import tableData from "../../../assets/json/vessel_df.json";
import { MatSort, Sort } from '@angular/material/sort';
import { TypeofExpr } from '@angular/compiler';
// import portData7 from "../../../assets/json/vessel_details_8feb_11am.json"
import { approvalService } from 'src/app/services/approval.service';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { DialogComponent } from '../dialog/dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { trailService } from 'src/app/services/trail.service';
interface USERS {
  probability,
  Ship, 
  master_operator, 
  DWT, 
  Tanks,
  eta_time,
  age,
  ship_type,
  stop_port_UNlocode,
  destination
}


@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css']
})

export class TableComponent implements OnInit{
  
  // User = new MatTableDataSource<any>();
  // @Input() data: number;
  @Output() mapevent = new EventEmitter<string>();
  @Output() dropevent = new EventEmitter<string>();
  startDate:any;
  endDate:any;
  // filterSelectObj = [];
  // filterValues = {};
  DWTFilterControl = new FormControl();
  AgeFilterControl = new FormControl();
  portData:MatTableDataSource<USERS>;
  operatorFilterControl = new FormControl();
  vesselFilterControl = new FormControl();
  dropName:any;
  simpleDialog: MatDialogRef<DialogComponent>;

  displayedColumns: string[] = ['probability','Ship', 'master_operator', 'DWT', 'age', "ship_type", "Tanks","eta_time","stop_port_UNlocode","destination"];
  User: MatTableDataSource<USERS>
  
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.User.filter = filterValue.trim().toLowerCase();

    if (this.User.paginator) {
      this.User.paginator.firstPage();
    }
  }

  constructor(private appService:approvalService,private _liveAnnouncer: LiveAnnouncer,private cdr: ChangeDetectorRef,private trailService: trailService,private dialogModel: MatDialog) {
    let currentYear = new Date().getFullYear();
    this.appService.currentApprovalStageMessage.subscribe(data =>
     {
        // this.User = data;
      // this.User = JSON.parse(JSON.stringify(data));
      // this.pokemon = res;
      // this.User.data = this.User;
      console.log(data)
      this.dropName = data;
      this.User = new MatTableDataSource(data);
      this.User.sort = this.sort;
       //here you indicate the paginator
       setTimeout(()=>{
        this.User.paginator = this.paginator;
       })
    }
      );

    console.log("dtdt",this.User);
    // this.User.forEach(
    //   item => item["age"] = Math.abs(item.Built - currentYear)
    // );
    // console.log(this.User);
    // this.User.sort((a,b) => a.name.localeCompare(b.name));

  }

  // ngOnChanges(){
  //   this.http.get(this.configUrl).subscribe(
  //     data => this.portData = data
  //   );
  // }
  

  DWTFilter = ["Under 10000","Between 10K And 20K","Between 20K And 30K","Between 30K And 40K","Between 40K And 50K", "Over 50K"];
  dwtFilter(event){
    
    if(event.target.value=="Under 10000"){

      this.User = this.dropName?.filter(
        (item)=> item.DWT < 10000 && item.DWT >= 0
      );
      // this.mapRangeChange(temp);
    }
    else if(event.target.value=="Between 10K And 20K"){
      let currentYear = new Date().getFullYear();


      this.User = this.dropName?.filter(
        (item)=> item.DWT < 20000 && item.DWT >= 10000
      );
      // this.mapRangeChange(temp);
    }
    else if(event.target.value=="Between 20K And 30K"){
      let currentYear = new Date().getFullYear();

      this.User = this.dropName?.filter(
        (item)=> item.DWT < 30000 && item.DWT >= 20000
      );
      // this.mapRangeChange(temp);
    }
    else if(event.target.value=="Between 30K And 40K"){
      let currentYear = new Date().getFullYear();

      this.User = this.dropName?.filter(
        (item)=> item.DWT < 40000 && item.DWT >= 30000
      );
      // this.mapRangeChange(temp);
    }
    else if(event.target.value=="Between 40K And 50K"){
      let currentYear = new Date().getFullYear();

      this.User = this.dropName?.filter(
        (item)=> item.DWT < 50000 && item.DWT >= 40000
      );
      // this.mapRangeChange(temp);
    }
    else if(event.target.value=="Over 50K"){
      let currentYear = new Date().getFullYear();

      this.User = this.dropName?.filter(
        (item)=>item.DWT >= 50000
      );
      // this.mapRangeChange(temp);
    }
    else{
      this.appService.currentApprovalStageMessage.subscribe(data =>
        {
         this.User = new MatTableDataSource(data);
         this.User.sort = this.sort;
  
          setTimeout(()=>{
           this.User.paginator = this.paginator;
          })
       }
         );
    }
  }

  AgeFilter = ["< 15","15 - 20","> 20"];
  ageFilter(event){
    if(event.target.value=="< 15"){
      let currentYear = new Date().getFullYear() - 15;
      console.log(currentYear);
      
      this.User = this.dropName?.filter(
        (item)=> item.Built > currentYear
      );
      // this.mapRangeChange(temp);
    }
    else if(event.target.value=="15 - 20"){
      let currentYear = new Date().getFullYear() - 15;
      let year = new Date().getFullYear() - 20;

      this.User = this.dropName?.filter(
        (item)=> item.Built > year && item.Built <= currentYear
      );
      // this.mapRangeChange(temp);
    }
    else if(event.target.value=="> 20"){
      let year = new Date().getFullYear() - 20;

      this.User = this.dropName?.filter(
        (item)=> item.Built <= year
      );
      // this.mapRangeChange(temp);
    }
    else{
      this.appService.currentApprovalStageMessage.subscribe(data =>
        {
         this.User = new MatTableDataSource(data);
         this.User.sort = this.sort;
  
          setTimeout(()=>{
           this.User.paginator = this.paginator;
          })
       }
         );
    }
  }

  vesselFilter(event){
    if(event.target.value){
      this.User = this.dropName?.filter(
        m=> m.Ship === event.target.value
      )
    }
    else{
      this.appService.currentApprovalStageMessage.subscribe(data =>
        {
         this.User = new MatTableDataSource(data);
         this.User.sort = this.sort;
  
          setTimeout(()=>{
           this.User.paginator = this.paginator;
          })
       }
         );
    }
  
  }

  operatorFilter(event){
    if(event.target.value){
      this.User = this.dropName?.filter(
        m=> m.master_operator === event.target.value
      )
      // this.User.sort = this.sort;
      // this.User.paginator = this.paginator;
    }
    else{
      this.appService.currentApprovalStageMessage.subscribe(data =>
        {
         this.User = new MatTableDataSource(data);
         this.User.sort = this.sort;
  
          setTimeout(()=>{
           this.User.paginator = this.paginator;
          })
       }
         );
    }
  }


  ngAfterViewInit(): void {
    // this.appService.currentApprovalStageMessage.subscribe(data => this.User = data);
    let currentYear = new Date().getFullYear();
    // this.User = JSON.parse(JSON.stringify(this.portData));
    // this.User = new MatTableDataSource(this.User);
    this.User.paginator = this.paginator;
    this.User.sort = this.sort;
    this.cdr.detectChanges();
  }

  announceSortChange(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  mapRangeChange(val) {
    
    this.appService.updateApprovalMessage(val);
    //  this.appService.updateApprovalMessage(val)
  }

  getRecord(row){
    // console.log(row);
    this.trailService.fetchData(row.mmsid)
  .subscribe((data:any) => {
    // console.log(data)
    this.trailService.updateApprovalMessage(data);
  });
    // this.clickedMarker(lat, lng, id);
    // let data = portData13.filter(
    //   m=> m.id == id
    // )
    // this.appService.updateApprovalMessage(data);
    // this.zone.run(() => {
      this.simpleDialog = this.dialogModel.open(DialogComponent,{
        data:{
          // id: id,
          lat: row.current_lat,
          lng: row.current_lon,
          // color: position_updated_within_7_days,
          // rot: last_known_position_heading,
          mmsi:row.mmsid,
          ship:row.Ship
        },
        position: {
          left: '10px',
          top: '10px',
        }
      });
  }
  

  ngOnInit(): void {
    // this.User.sort((a,b) => a.name.localeCompare(b.name));
    this.cdr.detectChanges();
    this.setFilters();
  }
  setFilters(){
    this.DWTFilterControl.setValue('');
  }

  downloadFile(data: any) {
    const replacer = (key, value) => (value === null ? '' : value); // specify how you want to handle null values here
    const header = Object.keys(this.User.data[0]);
    const csv = this.User.data.map((row) =>
      header
        .map((fieldName) => JSON.stringify(row[fieldName], replacer))
        .join(',')
    );
    csv.unshift(header.join(','));
    const csvArray = csv.join('\r\n');
  
    const a = document.createElement('a');
    const blob = new Blob([csvArray], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
  
    a.href = url;
    a.download = 'vesselData.csv';
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }
  

}
